export const isFileType = (fileName: string, fileTypes: string[]) => {
  const fileExtension = fileName.toLowerCase().split('.').pop()
  return fileTypes.includes(fileExtension || '')
}
